'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const capitalize = (text) => text[0].toUpperCase() + text.substr(1, text.length);

exports.capitalize = capitalize;
